import { render, staticRenderFns } from "./OrderTypeList.vue?vue&type=template&id=0525ae27"
import script from "./OrderTypeList.vue?vue&type=script&lang=js"
export * from "./OrderTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports